/* eslint-disable react/forbid-prop-types */
/* eslint-disable camelcase */
import { deconstructDoc } from 'helpers/deconstructDoc';
import Image from 'next/image';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styles from './styles';

const featureList = [
  {
    groupType: 'graphics_card',
    image: '/icons/icon-gpu.svg',
  },
  {
    groupType: 'cpu',
    image: '/icons/icon-cpu.svg',
  },
  {
    groupType: 'ram',
    image: '/icons/icon-ram.svg',
  },
  {
    groupType: 'primary_ssd',
    image: '/icons/icon-ssd.svg',
  },
  {
    groupType: 'cpu_cooling_system',
    image: '/icons/icon-cooling.svg',
  },
  {
    groupType: 'cpu_cooling system',
    image: '/icons/icon-cooling.svg',
  },
  {
    groupType: 'motherboard',
    image: '/icons/icon-motherboard.svg',
  },
  {
    groupType: 'display',
    image: '/icons/icon-display.webp',
  },

  {
    groupType: 'airflow',
    image: '/icons/unique-feature-types/airflow.png',
  },
  {
    groupType: 'chassis',
    image: '/icons/unique-feature-types/chassis.png',
  },
  {
    groupType: 'color',
    image: '/icons/unique-feature-types/color.png',
  },
  {
    groupType: 'dimension',
    image: '/icons/unique-feature-types/dimension.png',
  },
  {
    groupType: 'glass_design',
    image: '/icons/unique-feature-types/glass-design.png',
  },
  {
    groupType: 'power',
    image: '/icons/unique-feature-types/power.png',
  },
  {
    groupType: 'screen',
    image: '/icons/unique-feature-types/screen.png',
  },
  {
    groupType: 'weight',
    image: '/icons/unique-feature-types/weight.png',
  },
  {
    groupType: 'special_usp',
    image: '/icons/unique-feature-types/special_usp.png',
  },
];

const Models = ({ title, pcModels, modelsCardListData }) => {
  const [modelIndex, setModelIndex] = useState(0);
  const getFeatureImageByType = (type) => {
    return featureList.find((item) => item.groupType === type)?.image;
  };

  return (
    <>
      <div className="configure_columns_slice">
        <div className="configure_columns_container">
          <div className="title">
            <h1>{RichText.asText(title)}</h1>
          </div>
        </div>
        <div className="mobile_container">
          {modelsCardListData[modelIndex].isShowingUniqueList && (
            <div className="select_chassis">Select Your Chassis</div>
          )}
          <div className="models_container">
            {pcModels.length > 0 &&
              pcModels.map((pcModel, index) => {
                const handleSelection = () => setModelIndex(index);
                return (
                  pcModel !== null && (
                    <button
                      type="button"
                      className={`model_option ${
                        index === modelIndex ? 'active' : ''
                      } ${index}`}
                      key={pcModel?.model_id}
                      onClick={handleSelection}
                    >
                      {pcModel?.model_title}
                    </button>
                  )
                );
              })}
          </div>
        </div>
        <div className={`information_container mobile${modelIndex}`}>
          {pcModels.map((pcModel, idx) => {
            const { seo_title, seo_description, price, compare_at, slug } =
              pcModel;
            const modelTitle = pcModel?.model_title;
            const savedMoney = compare_at - price;

            const { options = [] } = deconstructDoc(pcModel);

            const baseOptions = options?.filter((option) => option.is_base);
            const uniqueInfoData = modelsCardListData[idx];
            return (
              <div className="column_information" key={idx}>
                <div className="column_title">
                  <h1>{modelTitle}</h1>
                  <p className="subtitle">{seo_title}</p>
                </div>

                <div className="information_block_container">
                  {uniqueInfoData?.isShowingThumbnailImage ||
                  uniqueInfoData?.isShowingUniqueList ? (
                    <div
                      className="config_card_image_container"
                      onClick={() =>
                        (window.location.href = `/pc-models/${slug}`)
                      }
                    >
                      {pcModel.thumb_image && (
                        <img draggable="false"
                          className="config_card_thumbnail_image"
                          src={pcModel.thumb_image}
                          alt={modelTitle}
                        />
                      )}
                    </div>
                  ) : (
                    <p className="summary">{seo_description}</p>
                  )}

                  {uniqueInfoData?.isShowingUniqueList === true ? (
                    <div className="information_block">
                      {uniqueInfoData?.uniqueInfoList?.map((item, idx) => {
                        const type = item?.feature_type;
                        let imagePath = null;
                        if (type !== 'None') {
                          const tempType = type?.replace(' ', '_');
                          imagePath = getFeatureImageByType(
                            tempType.toLowerCase()
                          );
                        }
                        return (
                          <div className="description_container" key={idx}>
                            {type !== 'None' ? (
                              <div className="image_icon">
                                {imagePath && (
                                  <Image draggable={false}
                                    src={imagePath}
                                    width={20}
                                    height={20}
                                    alt="image_icon"
                                  />
                                )}
                              </div>
                            ) : (
                              <div className="red_dot" />
                            )}
                            <div className="description">
                              <p>{item.unique_info}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="information_block">
                      {featureList.map((feature) => {
                        const featuredOption = baseOptions.find(
                          (option) => option.group_type === feature.groupType
                        );
                        return featuredOption ? (
                          <div
                            className="description_container"
                            key={feature.groupType}
                          >
                            <div className="image_icon">
                              <Image draggable={false}
                                src={feature.image}
                                width={20}
                                height={20}
                                alt="image_icon"
                              />
                            </div>
                            <div className="description">
                              <p>{featuredOption.title}</p>
                            </div>
                          </div>
                        ) : (
                          ''
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="bottom_container">
                  <div className="price_information_container">
                    <p className="currency">From MYR</p>
                    <div className="price_compare_container">
                      {savedMoney > 0 && (
                        <del>
                          <p className="compare_price">
                            RM {parseFloat(compare_at).toLocaleString()}
                          </p>
                        </del>
                      )}
                      <p className="price">
                        RM {parseFloat(price).toLocaleString()}
                      </p>
                    </div>
                    {savedMoney > 0 && (
                      <p className="saved_money">You save RM {savedMoney} MYR</p>
                    )}
                  </div>

                  <Link href={`/pc-models/${slug}`}>
                    <a href={`/pc-models/${slug}`} className="customise">
                      CUSTOMISE NOW
                    </a>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Models.propTypes = {
  title: PropTypes.any.isRequired,
  pcModels: PropTypes.array.isRequired,
};

export default Models;
